const PENDING_INVITE_KEY = 'pending_invite_key'

export const savePendingInvite = (dealUserKey: string) =>
  localStorage.setItem(PENDING_INVITE_KEY, dealUserKey)

export const getPendingInvite = () => localStorage.getItem(PENDING_INVITE_KEY)

export const clearPendingInvite = () =>
  localStorage.removeItem(PENDING_INVITE_KEY)

export const pendingInvitePath = (dealUserKey: string) =>
  `/invite/accept/${dealUserKey}`
